import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-requestcustomer-grid',
  templateUrl: './RequestCustomerGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => RequestCustomerGridComponent)}]
})
export class RequestCustomerGridComponent extends BaseGridComponent {
    lineItems: ent.RequestCustomer[] = [];
    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();

    cols: any[];


    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

        
   

    ngOnInit(): void {
       
        this.load();
    }

    public load(){
      
        
    }
    
    onAddLineItemClick(event: any){
        if (!this.lineItems){this.lineItems = []}
        var newLineItem = new ent.RequestCustomer();

        this.lineItems = [...this.lineItems, newLineItem];
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    onDeleteClick(event: any, lineItem: ent.RequestCustomer){
        this.lineItems = _.remove(this.lineItems, x=>x.ID !== lineItem.ID);
        this.lineItemsChanged.emit(this.lineItems.length);
    }

}